import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'

import { Box, Stack, Typography } from '@mui/material'
import { yupResolver } from '@hookform/resolvers/yup'

import { FormModal, PrimaryButton } from '../default'
import { FormInputText } from '../forms/formInputs'
import { FormValidationUploadBatchFile } from '../forms/formValidations'
import { acSetBatchFilesTablePagination, acUploadBatchFile } from '../../store/actions'

const defaultValues = {
    name: ''
}

const BatchFileUploadModal = ({ open, onClose, setSnackbarData, file }) => {

    const dispatch = useDispatch()

    const {
        isUploadingBatchFile,
        //hasErrorUploadedBatchFile
    } = useSelector(state => state.batchFiles)

    const { control, handleSubmit, reset, formState: { errors } } = useForm({
        defaultValues: defaultValues,
        resolver: yupResolver(FormValidationUploadBatchFile)
    })

    const displayFileSize = () => {
        if (!file?.size) {
            return <></>
        }

        const fileSizeInKb = file.size / 1000
        const fileSizeInMb = fileSizeInKb / 1000

        if (fileSizeInMb < 1) {
            return <>Tamanho: <strong>{fileSizeInKb.toFixed(3)}</strong> KB</>
        }

        return <>Tamanho: <strong>{fileSizeInMb.toFixed(3)}</strong> MB</>
    }

    const resetAndClose = () => {
        reset()
        onClose()
    }

    const onSubmit = handleSubmit((data) => {

        if (isUploadingBatchFile) {
            return
        }

        const isValidCSV = (f) => f && f.name.toLowerCase().endsWith('.csv')
        if (!file || !isValidCSV(file)) {
            resetAndClose()
            setSnackbarData({ open: true, severity: 'error', message: 'O arquivo deve ser do formato .csv!' })
            return
        }

        const formData = new FormData()
        formData.append(data.name, file)

        dispatch(acUploadBatchFile(formData))
            .then(() => {
                resetAndClose()
                setSnackbarData({ open: true, severity: 'success', message: 'Lote enviado para processamento!' })
                dispatch(acSetBatchFilesTablePagination({ pageIndex: 0, pageSize: 10 }))
            })
            .catch(error => {
                console.error(error)
                resetAndClose()
                setSnackbarData({ open: true, severity: 'error', message: 'Erro no upload do arquivo!' })
            })

    })

    return (
        <FormModal
            open={open} onClose={resetAndClose}
            title='Upload de arquivo CSV para consulta em lote'
        >
            <Box component='form' onSubmit={onSubmit} noValidate
                display='flex' flexDirection='column' gap={2}
            >

                <FormInputText
                    name='name'
                    label='Nome do Lote'
                    control={control}
                    errors={errors.name}
                    fullWidth
                    required
                />

                <Stack gap={0.5}>
                    <Typography>
                        Arquivo: <strong>{file?.name}</strong>
                    </Typography>
                    <Typography>
                        {displayFileSize()}
                    </Typography>
                    <Typography>
                        Tipo: <strong>{file?.type}</strong>
                    </Typography>
                </Stack>

                {/** TO-DO: adicionar erro aqui ao invés de snackbar */}

                <PrimaryButton
                    label='Importar Lote'
                    loading={isUploadingBatchFile}
                    type='submit'
                    fullWidth
                />
            </Box>
        </FormModal>
    )

}

BatchFileUploadModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    setSnackbarData: PropTypes.func.isRequired,
    file: PropTypes.instanceOf(File)
}

export default BatchFileUploadModal